import { EventStatus } from '../enums';

/** Statuses that count as "still open" — everything except done/cancelled. */
export const NOT_COMPLETE_STATUSES: EventStatus[] = [
  EventStatus.DRAFT,
  EventStatus.SCHEDULED,
  EventStatus.CONFIRMED,
  EventStatus.IN_PROGRESS,
  EventStatus.POSTPONED,
];

export type StatusGroup = 'not_complete';

/** The fixed preset tabs of the task board (department-agnostic). */
export type TaskTier = 'mine' | 'dept_pending' | 'dept_all' | 'all' | 'backlog';

/**
 * Query params a tier maps to. Department scoping is NOT included here — the
 * server auto-scopes non-admins to their own department, and the admin
 * department override is applied by the calendar page.
 */
export interface TaskTierParams {
  task_only: true;
  assigned_to?: string;
  status_group?: StatusGroup;
  undated?: boolean;
}

export function resolveTaskTierQuery(tier: TaskTier, userId: string): TaskTierParams {
  switch (tier) {
    case 'mine':
      return { task_only: true, assigned_to: userId };
    case 'dept_pending':
      return { task_only: true, status_group: 'not_complete' };
    case 'dept_all':
      return { task_only: true };
    case 'all':
      return { task_only: true };
    case 'backlog':
      return { task_only: true, undated: true };
  }
}
